import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { actions } from "react-redux-form";
import { InputFieldFloatingLabel as InputField, SelectFieldFloatingLabel as Select  } from '../../../../../common/custom-form/select-filter.component';
import Translation from '../../../../../common/translation/translation.component';
import DATEPICKER_OR from '../../../../../common/custom-form/custom-date-picker.component';
import { TRANSLATIONS as translation } from "../../../../../../utils/constant.utils";
import { MAX_LENGTH, RECHARGE_INVENTORY_TYPE, WORKFLOW_MESSAGE } from '../../../../../../constants/external-constants';
import { connect } from 'react-redux';
import CustomSearchableSelectWrapper from '../../../../../common/custom-form/custom-searchable-select-wrapper.component';
import MappingInformation from '../../recharging-details-inventory/mapping-information/mapping-information.component';
import LocationInformation from '../../recharging-details-inventory/location-information/location-information.component';
import { ConfirmationModal } from '../../../../../common/modal/modal.component';
import { NotificationModal } from '../../../../../common/modal/notification-modal.component';
import { Button } from 'react-bootstrap';
import EquipmentAdditionalInformation from '../equipment-additional-information/equipment-additional-information.component';
import { RechargeInventoryDetailsActions } from '../../../../../../store/external/recharge-reducer/recharge-inventory-details.reducer/recharge-inventory-details.reducer';
import { generateEquipmentNumber, isObjectEqual, areDataEqual } from '../../../../../../utils/helpers.utils';
import { Loading } from "../../../../../common/loading";
import { ACCESS_MODULE, MATRIX_INDICATOR } from '../../../../../../utils/rbac-constants.utils';
import { validateAccessModule } from '../../../../../../utils/helpers.utils';
import CustomSearchableDropdownWrapper from '../../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper';

class RechargingEquipmentForm extends Component {
    constructor(props){
        super(props);
        this.state={
            saveModal: {
                title: "",
                messageBody: "",
                confirmAction: () => { }
            },
            saveNotif: {
                show: false,
                title: "",
                message: ""
            },
            isLoading: false,
            isSaving: false,
            originalMappingInformationData: {},
        }
        this.ConfirmationModal = React.createRef();
    }

  async componentDidMount(){
        const { rechargeInventoryDetailsForm, isCreateNew, setEquipmentNumber, setFormDefaultDetails, getRechargeInventory, rechargeInventoryId, getMappingInformationList } = this.props;
        this.setState({ isLoading: true });
    
            if(isCreateNew){
                this.props.resetRechargeInventoryDetailForm();
                if(rechargeInventoryDetailsForm.equipmentInformation.equipmentNumber === ""){
                    const equipmentNumber = generateEquipmentNumber();
                    setEquipmentNumber(equipmentNumber);
                }
                setFormDefaultDetails(RECHARGE_INVENTORY_TYPE["Equipment"].label);    
                this.setState({ isLoading: false });

                await this.props.getRequestorOption(1);
                await this.props.getRechargingPersonOption(1);
                await this.props.getEndUserOption(1);
                await this.props.getLocationOption(1);
                await this.props.getVendorOption(1);
            }
            else {
                await getRechargeInventory(rechargeInventoryId);

                const { data } = this.props.rechargeInventoryDetails.rechargeInventoryData;

                await this.props.getRequestorOption(1, data.RequestorEmail);
                await this.props.getRechargingPersonOption(1, data.RechargePersonEmail);
                await this.props.getEndUserOption(1, data.EndUserEmail);
                await this.props.getLocationOption(1, data.LocationCode);
                await this.props.getVendorOption(1, data.VendorName);
            }

            await getMappingInformationList(rechargeInventoryId).then(() =>{
                const originalMappingInformationDataCopy = JSON.parse(JSON.stringify(this.props.rechargeInventoryDetails.mappingInformationList));
                this.setState({  originalMappingInformationData: originalMappingInformationDataCopy })
            });
        this.setState({ isLoading: false });
        }
    
    componentWillUnmount() {
        this.props.resetRechargeInventoryDetailForm();
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    disableSaveChanges = () => {
        const { $form, rechargeInventoryDetailsForm, rechargeInventoryDetails, isCreateNew } = this.props
        const { rechargeInventory, additionalInformation, locationInformation, equipmentInformation  } = rechargeInventoryDetailsForm;
        const { operationalStatusId,
                rechargeQuantity } = rechargeInventory;
        const { equipmentDDI,
                equipmentTypeId,
                deliveryDate,
                installDate } = equipmentInformation;
        const { locationId } = locationInformation;      

        const isFieldEmpty = !equipmentDDI || !equipmentTypeId || !deliveryDate || !installDate || !operationalStatusId  || !rechargeQuantity || !locationId;
            
        if (isFieldEmpty) {
            return true;
        }

        if(!isCreateNew){
        
            const loaded = $form?.loadedValue;

            const unchangedRechargeInventoryDetails = !loaded || isObjectEqual(loaded.rechargeInventory, rechargeInventory);
            const unchangedEquipmentInformation = !loaded || isObjectEqual(loaded.equipmentInformation, equipmentInformation);
            const unchangedAdditionalInformation = !loaded || isObjectEqual(loaded.additionalInformation, additionalInformation);
            const unchangedLocationInformation = !loaded || parseInt(loaded.locationInformation?.locationId) === parseInt(locationInformation.locationId);

            const mappingInformationDetails = rechargeInventoryDetails?.mappingInformationList?.datatable?.length > 0
                            ? areDataEqual(this.state.originalMappingInformationData?.datatable?.[0], rechargeInventoryDetails?.mappingInformationList?.datatable?.[0])
                            : true;
            return unchangedRechargeInventoryDetails && unchangedAdditionalInformation && unchangedLocationInformation && unchangedEquipmentInformation && mappingInformationDetails;
        
        }

        return false;
    }

    handleButtonConfirmation = async (rechargeInventoryId) => {
        const { saveRechargeInventory, getRechargeInventory, getMappingInformationList } = this.props;

        this.setState({
            isSaving: true
        });

        var result = await saveRechargeInventory(rechargeInventoryId);

        this.setState({
            isSaving: false
        });

        if (result.success === true) {
            // Refresh form with updated values
            await getRechargeInventory(rechargeInventoryId);
            getMappingInformationList(rechargeInventoryId).then(() => {
                const originalMappingInformationDataCopy = JSON.parse(JSON.stringify(this.props.rechargeInventoryDetails.mappingInformationList));
                this.setState({ originalMappingInformationData: originalMappingInformationDataCopy })
            });

            this.toggleSaveNotif(true, this.toLocaleLanguage("success_modal_title"), result.message);
            return;
        }
        else {
            this.toggleSaveModal(false);
            this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title", false), result.message);
            return;
        }
    }

    handleChangesStatus = (prop, truthValue) =>{
        this.setState({
            [prop]: truthValue
        })
    }

    toggleSaveNotif = (isShow, title, message) => {
        const { saveNotif } = this.state;
        const { closeFormAction, resetRechargeInventoryDetailForm } = this.props

        this.setState({
            saveNotif: {
                ...saveNotif,
                show: isShow,
                title: title ?? "",
                message: message ?? "",
            }
        });

        if (!isShow && saveNotif.message === this.toLocaleLanguage("recharge_equipment_created")) {
            closeFormAction();
            resetRechargeInventoryDetailForm();
        }

    }

    toggleSaveModal = (isShow, title, message, confirmAction = () => { }) => {
        const { saveModal } = this.state;
        
        if (isShow) {
            this.ConfirmationModal.current.handleShow();
        }
        else {
            this.ConfirmationModal.current.handleClose();
        }
        
        this.setState({
            saveModal: {
                ...saveModal,
                title: title ?? "",
                messageBody: message ?? "",
                confirmAction: confirmAction
            },
        });
    }

    loadUpdatedMappingInfo = (data) => {
        this.setState({
            originalMappingInformationData: data
        })
    }

    handleRechargingPersonSearch = (searchString) => {
        this.props.getRechargingPersonOption(1, searchString)
    }

    loadMoreRechargingPerson = (searchString) => {
        const { rechargingPersonPage } = this.props.rechargeInventoryDetails;

        this.props.getRechargingPersonOption(rechargingPersonPage + 1, searchString);
    }

    handleRequestorSearch = (searchString) => {
       this.props.getRequestorOption(1, searchString)
    }

    loadMoreRequestor = (searchString) => {
        const { requestorPage } = this.props.rechargeInventoryDetails;

        this.props.getRequestorOption(requestorPage + 1, searchString);
    }

    handleEndUserSearch = (searchString) => {
        this.props.getEndUserOption(1, searchString)
    }

    loadMoreEndUser = (searchString) => {
        const { endUserPage } = this.props.rechargeInventoryDetails;

        this.props.getEndUserOption(endUserPage + 1, searchString);
    }

    handleVendorSearch = (searchString) => {
        this.props.getVendorOption(1, searchString)
    }

    loadMoreVendor = (searchString) => {
        const { vendorPage } = this.props.rechargeInventoryDetails;

        this.props.getVendorOption(vendorPage + 1, searchString);
    }

    render() {
        const { rechargeInventoryDetails, rechargeInventoryDetailsForm, isCreateNew, rechargeInventoryId } = this.props
        const { rechargeInventory, equipmentInformation } = rechargeInventoryDetailsForm

        const hasNotification = rechargeInventoryDetails.mappingInformationList?.datatable[0]?.dataItem.length > 0 ?
            (rechargeInventoryDetails.mappingInformationList?.datatable[0]?.dataItem[0].MappingStatusID == 3
                || rechargeInventoryDetails.mappingInformationList?.datatable[0]?.dataItem[0].MappingStatusID == 4) : false;

        const isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdRechargingInventoryRW])
        return (
            <>
                {
                    this.state.isLoading || this.state.isSaving ?
                        <Loading />
                        :
                        <>
                            <div className="details-field-container capital-uppercase">
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={<Translation translationKey={"equipment_number"} />}
                                    value={equipmentInformation.equipmentNumber}
                                    fieldProp='rechargeInventoryDetailsForm.equipmentInformation.equipmentNumber'
                                    disabled={true}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                    maxLength={MAX_LENGTH.inputText}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={<Translation translationKey={"equipment_ddi"} />}
                                    value={equipmentInformation.equipmentDDI}
                                    fieldProp='rechargeInventoryDetailsForm.equipmentInformation.equipmentDDI'
                                    disabled={false}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                    maxLength={MAX_LENGTH.limit_100}
                                    requiredField={true}
                                />
                                <Select
                                    className="form-select required"
                                    label={<Translation translationKey={"equipment_type"} />}
                                    value={equipmentInformation.equipmentTypeId}
                                    options={rechargeInventoryDetails.rechargeInventoryDetailsDropDownList.EquipmentType}
                                    placeholder={this.toLocaleLanguage('select_placeholder', false)}
                                    fieldProp='rechargeInventoryDetailsForm.equipmentInformation.equipmentTypeId'
                                    disabled={false}
                                />
                                <Select
                                    className="form-select required"
                                    label={<Translation translationKey={"operational_status"} />}
                                    options={rechargeInventoryDetails.rechargeInventoryDetailsDropDownList?.OperationalStatus}
                                    value={rechargeInventory.operationalStatusId}
                                    placeholder={this.toLocaleLanguage('select_placeholder', false)}
                                    fieldProp='rechargeInventoryDetailsForm.rechargeInventory.operationalStatusId'
                                    onChangeAction={this.onChangeDisputeType}
                                    optionLabelKey={{
                                        Key: "Key",
                                        Value: "Value"
                                    }}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={<Translation translationKey={"recharging_inventory_type"} />}
                                    value={rechargeInventory.rechargeInventoryType}
                                    fieldProp='rechargeInventoryDetailsForm.rechargeInventory.rechargeInventoryType'
                                    disabled={true}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                    maxLength={MAX_LENGTH.inputText}
                                />
                                <CustomSearchableDropdownWrapper
                                    label={this.toLocaleLanguage("vendor")}
                                    options={rechargeInventoryDetails.vendorOptions}
                                    selected={rechargeInventory.vendorId}
                                    onChange={() => { }}
                                    placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                    fieldProp='rechargeInventoryDetailsForm.rechargeInventory.vendorId'
                                    isNullable={true}
                                    tagName='tagName'
                                    optionLabelKey={{
                                        Key: 'Key',
                                        Value: 'Value'
                                    }}
                                    maxLength={MAX_LENGTH.inputText}
                                    disabled={false}

                                    onSearchChange={this.handleVendorSearch}
                                    onLoadMore={this.loadMoreVendor}
                                    isLoading={rechargeInventoryDetails.isVendorLoading}
                                    hasMore={rechargeInventoryDetails.hasMoreVendor}
                                />
                                <DATEPICKER_OR
                                    dateOnly={true}
                                    label={<Translation translationKey={"delivery_date"} />}
                                    placeholder={`${this.toLocaleLanguage('select_date')}`}
                                    startDate={equipmentInformation.deliveryDate}
                                    selectedDate={(date) => this.props.FormChange("rechargeInventoryDetailsForm.equipmentInformation.deliveryDate", date)}
                                    isDisable={false}
                                    requiredField={true}
                                />
                                <DATEPICKER_OR
                                    dateOnly={true}
                                    label={<Translation translationKey={"install_date"} />}
                                    placeholder={`${this.toLocaleLanguage('select_date')}`}
                                    startDate={equipmentInformation.installDate}
                                    selectedDate={(date) => this.props.FormChange("rechargeInventoryDetailsForm.equipmentInformation.installDate", date)}
                                    isDisable={false}
                                    requiredField={true}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={<Translation translationKey={"recharging_quantity"} />}
                                    value={rechargeInventory.rechargeQuantity}
                                    fieldProp='rechargeInventoryDetailsForm.rechargeInventory.rechargeQuantity'
                                    disabled={false}
                                    placeholder={"1.00000"}
                                    requiredField={true}
                                    hasDecimalLimit={true}
                                    decimalFormat={[18, 5]}
                                />
                                <CustomSearchableDropdownWrapper
                                    label={this.toLocaleLanguage("end_user")}
                                    options={rechargeInventoryDetails.endUserOptions}
                                    selected={equipmentInformation.equipmentEndUserId}
                                    onChange={() => { }}
                                    placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                    fieldProp='rechargeInventoryDetailsForm.equipmentInformation.equipmentEndUserId'
                                    isNullable={true}
                                    tagName='tagName'
                                    optionLabelKey={{
                                        Key: 'Key',
                                        Value: 'Value'
                                    }}
                                    maxLength={MAX_LENGTH.inputText}
                                    disabled={false}

                                    onSearchChange={this.handleEndUserSearch}
                                    onLoadMore={this.loadMoreEndUser}
                                    isLoading={rechargeInventoryDetails.isEmployeeLoading}
                                    hasMore={rechargeInventoryDetails.hasMoreEndUser}
                                />
                                <CustomSearchableDropdownWrapper
                                    label={this.toLocaleLanguage("requestor")}
                                    options={rechargeInventoryDetails.requestorOptions}
                                    selected={equipmentInformation.equipmentRequestorId}
                                    onChange={() => { }}
                                    placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                    fieldProp='rechargeInventoryDetailsForm.equipmentInformation.equipmentRequestorId'
                                    isNullable={true}
                                    tagName='tagName'
                                    optionLabelKey={{
                                        Key: 'Key',
                                        Value: 'Value'
                                    }}
                                    maxLength={MAX_LENGTH.inputText}
                                    disabled={false}

                                    onSearchChange={this.handleRequestorSearch}
                                    onLoadMore={this.loadMoreRequestor}
                                    isLoading={rechargeInventoryDetails.isEmployeeLoading}
                                    hasMore={rechargeInventoryDetails.hasMoreRequestor}
                                />
                                <CustomSearchableDropdownWrapper
                                    label={this.toLocaleLanguage("recharging_person")}
                                    options={rechargeInventoryDetails.rechargingPersonOptions}
                                    selected={rechargeInventory.rechargePersonId}
                                    onChange={() => { }}
                                    placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                                    fieldProp='rechargeInventoryDetailsForm.rechargeInventory.rechargePersonId'
                                    isNullable={true}
                                    tagName='tagName'
                                    optionLabelKey={{
                                        Key: 'Key',
                                        Value: 'Value'
                                    }}
                                    maxLength={MAX_LENGTH.inputText}
                                    disabled={false}

                                    onSearchChange={this.handleRechargingPersonSearch}
                                    onLoadMore={this.loadMoreRechargingPerson}
                                    isLoading={rechargeInventoryDetails.isEmployeeLoading}
                                    hasMore={rechargeInventoryDetails.hasMoreRechargingPerson}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={<Translation translationKey={"service_instance_id"} />}
                                    value={rechargeInventory?.serviceInstanceId}
                                    fieldProp='rechargeInventoryDetailsForm.rechargeInventory.serviceInstanceId'
                                    disabled={false}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                    maxLength={MAX_LENGTH.limit_255}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={<Translation translationKey={"output_record_id"} />}
                                    value={rechargeInventory?.outputRecordId}
                                    fieldProp='rechargeInventoryDetailsForm.rechargeInventory.outputRecordId'
                                    disabled={true}
                                    maxLength={MAX_LENGTH.inputText}
                                />
                            </div>
                            <div className="collapsable-items-wrapper">
                                <div className="horizontal-separator" />
                                <MappingInformation
                                    translator={this.toLocaleLanguage}
                                    handleChangesStatus={this.handleChangesStatus}
                                    isCreateNew={isCreateNew}
                                    rechargeInventoryId={rechargeInventoryId}
                                    loadUpdatedMappingInfo={this.loadUpdatedMappingInfo}                                    
                                    isReadAndWrite={isReadAndWrite}
                                />
                                <EquipmentAdditionalInformation translator={this.toLocaleLanguage} />
                                <LocationInformation translator={this.toLocaleLanguage} />
                            </div>

                            {hasNotification ?
                                <span className="pending-approval-message">{WORKFLOW_MESSAGE.refreshMappingWorkflow}</span>
                                : ''
                            }
                            <div className='save-btn-container'>
                                <ConfirmationModal
                                    ref={this.ConfirmationModal}
                                    title={this.state.saveModal.title}
                                    messageBody={this.state.saveModal.messageBody}
                                    confirmAction={this.state.saveModal.confirmAction}
                                    closeLabel={this.toLocaleLanguage("cancel_button")}
                                    confirmLabel={this.toLocaleLanguage("yes_button")}
                                    disabled={this.state.isSaving}
                                />

                                <NotificationModal
                                    show={this.state.saveNotif.show}
                                    title={this.state.saveNotif.title}
                                    message={this.state.saveNotif.message}
                                    handleModal={() => this.toggleSaveNotif(false)}
                                    customClass={'comment-notification-modal modal-text-bold notification-footer'}
                                />

                                {
                                    isReadAndWrite &&
                                        <div className="tooltip-container">
                                            <div className="btn-tooltiptext">
                                                {true ?
                                                    <Button className='save-details-btn btn btn-primary'
                                                        disabled={this.disableSaveChanges()}
                                                        onClick={() => this.handleButtonConfirmation(this.props.rechargeInventoryId)}
                                                        type="button">
                                                        Save Changes
                                                    </Button>
                                                    : null}
                                                <div className="save-tooltip-text-container">
                                                    <span className="tooltip-text-save">{this.toLocaleLanguage("save_equip_info", false)}</span>
                                                </div>
                                            </div>
                                        </div>
                                }

                            </div>
                        </>}
            </>
        )
    }
}

export default withRouter(connect(
    state => {
        const { rechargeInventoryDetails, translation } = state;
        const { rechargeInventoryDetailsForm, forms: { rechargeInventoryDetailsForm: { $form } } } = state.form;
        return {
            ...translation,
            rechargeInventoryDetails,
            rechargeInventoryDetailsForm,
            $form
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, RechargeInventoryDetailsActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        },
        FormLoad: (model, data) => {
            dispatch(actions.load(model, data));
        }
    })
)(RechargingEquipmentForm));